import { render, staticRenderFns } from "./IntegratedModelList.vue?vue&type=template&id=91a35680&scoped=true"
import script from "./IntegratedModelList.vue?vue&type=script&lang=js"
export * from "./IntegratedModelList.vue?vue&type=script&lang=js"
import style0 from "./IntegratedModelList.vue?vue&type=style&index=0&id=91a35680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a35680",
  null
  
)

export default component.exports